module.exports = __webpack_public_path__ + "static/img/logo.e09f3cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wardrobeImg/logo.jpg
// module id = DEGG
// module chunks = 1